import { Navigate, Outlet } from 'react-router';
import { AppRoutes } from 'UI/router';
import { useAuthentication } from 'UI/hooks/useAuthentication';
import { observer } from 'mobx-react-lite';
import { app } from 'application';
import { LoadingPage } from 'UI/pages/LoadingPage/LoadingPage';

function AuthLayoutComponent(): React.ReactElement {
  const { authed } = useAuthentication();

  if (app().userStore.isAuthenticating) {
    return <LoadingPage />;
  }

  if (authed) {
    return <Navigate to={AppRoutes.Dashboard.CategoriesManagement()} replace={true} />;
  }

  return (
    <>
      <Outlet />
    </>
  );
}

const AuthLayout = observer(AuthLayoutComponent);

export { AuthLayout };
